import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgxPermissionsModule} from 'ngx-permissions';
import {SliderModule} from 'primeng/slider';
import {ImageCropperComponent as NgxImageCropperComponent} from 'ngx-image-cropper';
import {AspectRatioDirective} from '../../core/directives/aspect-ratio.directive';
import {EndCapModule} from '../end-cap/end-cap.module';
import {SpinnerModule} from '../spinner/spinner.module';
import {ImageCropperComponent} from './image-cropper.component';
import {HeaderBackdropComponent} from '../background-panel/header-backdrop.component';

@NgModule({
  imports: [CommonModule, FormsModule, NgOptimizedImage, TranslateModule, NgxPermissionsModule,
    SliderModule, NgxImageCropperComponent, AspectRatioDirective, EndCapModule, SpinnerModule, HeaderBackdropComponent],
  declarations: [ImageCropperComponent],
  exports: [ImageCropperComponent],
})
export class ImageCropperModule {}
